function getLibelleSociete(societes, id) {
  const societeFind = societes.find((s) => { return s.id === id; });
  return societeFind ? societeFind.libelle : null;
}

export default function traductionMessageCommentaireInterne(messages, societes) {
  const errors = [];
  const messagesSplit = messages.split('###');
  messagesSplit.forEach((message) => {
    if (message.indexOf('NO_DELAI') === 0) {
      const elements = message.split('|')[0].split('@');
      errors.push({
        message: 'detailCommande.achatVenteInterne.error.noDelai',
        params: {
          societeCourante: getLibelleSociete(societes, elements[1]),
          societeTiers: getLibelleSociete(societes, elements[2]),
        },
      });
    }
    if (message.indexOf('NO_PAYMENT_METHODE') === 0) {
      const elements = message.split('|')[0].split('@');
      errors.push({
        message: 'detailCommande.achatVenteInterne.error.noPaiementMethode',
        params: {
          societeCourante: getLibelleSociete(societes, elements[1]),
          societeTiers: getLibelleSociete(societes, elements[2]),
        },
      });
    }
    if (message.indexOf('NO_PROVIDER') === 0) {
      const elements = message.split('|')[0].split('@');
      errors.push({
        message: 'detailCommande.achatVenteInterne.error.noProvider',
        params: {
          societeCourante: getLibelleSociete(societes, elements[1]),
          societeTiers: getLibelleSociete(societes, elements[2]),
        },
      });
    }
    if (message.indexOf('NO_AGENCY') === 0) {
      const elements = message.split('|')[0].split('@');
      errors.push({
        message: 'detailCommande.achatVenteInterne.error.noAgency',
        params: {
          societeCourante: getLibelleSociete(societes, elements[1]),
        },
      });
    }
    if (message.indexOf('NO_SOCIETE_TIERS') === 0) {
      errors.push({ message: 'detailCommande.achatVenteInterne.error.noSocieteTiers' });
    }
    if (message.indexOf('NO_PRODUCT') === 0) {
      errors.push({ message: 'detailCommande.achatVenteInterne.error.noProduct' });
    }
    if (message.indexOf('ACCOUNTING_ACCOUNT_REQUIRED') === 0) {
      errors.push({ message: 'detailCommande.achatVenteInterne.error.accountingAccountRequired' });
    }
  });
  return errors;
}
